import React from 'react';
import { Grid, Typography, Container } from '@mui/material';
import { keyframes } from '@mui/system';
import PastWorkCard from './PastWorkCard';

const pastWorks = [
  {
    title: 'Project 1',
    videoUrl: 'https://www.youtube.com/embed/Ss3BtDtA4VQ', // Embed URL
  },
  {
    title: 'Project 2',
    videoUrl: 'https://www.youtube.com/embed/Ss3BtDtA4VQ', // Embed URL
  }
 
];

const animateText = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const PastWorks = () => {
  return (
    <Container>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          animation: `${animateText} 2s ease-in-out`,
        }}
      >
        Our Past Works
      </Typography>
      <Grid container spacing={4}>
        {pastWorks.map((work, index) => (
          <PastWorkCard key={index} work={work} />
        ))}
      </Grid>
    </Container>
  );
};

export default PastWorks;
